import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStorefront = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31 14.5V9H9V14.5V31H17.25V24.5833H22.75V31H31V14.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 15.4165V16.3332C14.5 17.8548 13.2717 19.0832 11.75 19.0832C10.2283 19.0832 9 17.8548 9 16.3332V15.4165",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 15.4165V16.3332C20 17.8548 18.7717 19.0832 17.25 19.0832C15.7283 19.0832 14.5 17.8548 14.5 16.3332V15.4165",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 15.4165V16.3332C25.5 17.8548 24.2717 19.0832 22.75 19.0832C21.2283 19.0832 20 17.8548 20 16.3332V15.4165",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 15.4165V16.3332C31 17.8548 29.7717 19.0832 28.25 19.0832C26.7283 19.0832 25.5 17.8548 25.5 16.3332V15.4165",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgStorefront);
export default ForwardRef;
